import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  resolveCaseRoleAccessAPI,
  getByIdCaseRoleAccessAPI,
  saveCaseRoleAccessAPI,
  listCaseRoleAccessAPI,
  setActiveCaseRoleAccessAPI,
  deleteCaseRoleAccessAPI,
} from "../../../api/caseRoleAccess_api";

export const resolveCaseRoleAccessAction = createAsyncThunk(
  "caseRoleAccess/resolve",
  async (params, { rejectWithValue }) => {
    const response = await resolveCaseRoleAccessAPI(params);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  }
);

export const getByIdCaseRoleAccessAction = createAsyncThunk(
  "caseRoleAccess/getById",
  async (id, { rejectWithValue }) => {
    const response = await getByIdCaseRoleAccessAPI(id);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  }
);

export const saveCaseRoleAccessAction = createAsyncThunk(
  "caseRoleAccess/save",
  async (payload, { rejectWithValue }) => {
    const response = await saveCaseRoleAccessAPI(payload);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  }
);

export const listCaseRoleAccessAction = createAsyncThunk(
  "caseRoleAccess/list",
  async (params, { rejectWithValue }) => {
    const response = await listCaseRoleAccessAPI(params);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  }
);

export const setActiveCaseRoleAccessAction = createAsyncThunk(
  "caseRoleAccess/setActive",
  async ({ id, isActive }, { rejectWithValue }) => {
    const response = await setActiveCaseRoleAccessAPI({ id, isActive });
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return { id, isActive };
  }
);

export const deleteCaseRoleAccessAction = createAsyncThunk(
  "caseRoleAccess/delete",
  async (id, { rejectWithValue }) => {
    const response = await deleteCaseRoleAccessAPI(id);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return id;
  }
);
